import request from 'src/api'
import deleteRecord from 'src/deleteRecord'
import moment from 'moment-timezone' // https://momentjs.com/
import { addToast } from 'src/toasts'
import { lockButton, unlockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import functions_contact_person from 'packs/customers/functions_contact_person'
// F-85. NOT imported: the events tab is removed from the customer UI, and this module pulls in
// @fullcalendar/core, /timegrid and /interaction. Leaving the import out is what kept them out of the
// bundle — verified 2026-10-12: every library symbol (`timeGridPlugin`, `interactionPlugin`,
// `dayGridMonth`, `fc-event`, `fc-timegrid`, `CalendarRoot`, `preact`) returns **0** hits in the shipped
// `application-*.js`. 📌 Grepping the capitalised product name instead returns **1** — this comment, since
// a development build keeps comments. Search for a symbol, not the name.
// 🚨 **And `T-101` deleted the events UI entirely on 2026-10-15**, `functions_event.js` with it. The
// `Event` model and table stay, because `customer.events` is part of the access predicate in nine
// `set_customer` copies. To bring the feature back, see `docs/AUTH.md` → *Events UI — REMOVED*, which names
// the commit to restore from.
import functions_service_description from 'packs/customers/functions_service_description'
import functions_contract from 'packs/customers/functions_contract'
import functions_contract_extra from 'packs/customers/functions_contract_extra'
import functions_quality_control from 'packs/customers/functions_quality_control'
import functions_attachment from 'packs/customers/functions_attachment'
import functions_notes from 'packs/customers/functions_notes'
import { showGoogleMap } from 'src/googleMap'
import initHistoryLoadMore from 'src/historyLoadMore'
import withDirtyGuard from 'src/dirtyNav'
import showTemplateInModal from 'src/showTemplateInModal'

function customerFunctions() {
  // 🔑 **TODO.md F-189. Confirm the own-booking flag before a NEW customer is saved.** Owner, 2026-10-26.
  // The template is rendered only when `@customer.id` is blank, so its presence IS the "is this a
  // creation" test — no role or state check to keep in step with the view.
  // 📌 The value shown is read from the checkbox, not from the server: on a new customer there is no
  // stored flag yet, so the only true answer is what the user has just ticked.
  // ⚠️ `ownBookingConfirmed` is a one-shot latch rather than a flag that stays set — the Continue button
  // re-clicks the real submit, and without clearing it immediately the SECOND save of a later customer
  // would skip the confirmation.
  // 🚨 **`#offcanvasRight`, and I had this WRONG first time — read this before "fixing" the container.**
  // I bound it on `#content`, reasoning that the customer's basic-information form lives in the page while
  // the contract form this came from lives in the offcanvas. It does not: `customers/_header.html.erb`
  // renders its save button inside `#offcanvasRightButtons`, so the customer form is in the offcanvas too.
  // The modal simply never appeared, and two browser scenarios caught it.
  // 🔑 So the move was smaller than it looked: the container is unchanged, and only the TEMPLATE's
  // location and the checkbox's id differ from `F-170`'s contract version.
  $('#offcanvasRight').off('.ownBooking')
  $('#offcanvasRight').on('click.ownBooking', '#submitForm', function(event) {
    const template = document.getElementById('ownBookingConfirmTemplate')

    if (window.ownBookingConfirmed) { window.ownBookingConfirmed = false; return }
    if (!template) { return }

    event.preventDefault()

    // 🚨 **`unlockButton` before showing, or the modal opens UNDER the fullscreen loader.** The submit
    // click has already locked the button and raised the loader by the time this runs — a global handler
    // does that for every form submit — and `preventDefault` stops the request, not the loader. Measured:
    // Chrome refused the Continue click with *"Other element would receive the click:
    // div.loader-background"*. It also re-enables `#submitForm`, which the re-click below needs.
    unlockButton('#submitForm')

    const checked = $('#customer_own_booking').is(':checked')
    showTemplateInModal(template)
    $('#mainModal .own-booking-yes').toggleClass('d-none', !checked)
    $('#mainModal .own-booking-no').toggleClass('d-none', checked)
    mainModal.show()
  })

  // 📌 Re-clicking `#submitForm` rather than calling `.submit()`: the button carries `name="commit"`, and
  // a programmatic form submit drops it — the server branches on the commit parameter elsewhere in this
  // controller, so losing it is the kind of thing that works until it does not.
  $('#mainModal').off('.ownBooking')
  $('#mainModal').on('click.ownBooking', '#confirmOwnBookingCreate', function(event) {
    window.ownBookingConfirmed = true
    mainModal.hide()
    $('#submitForm').click()
  })


  initHistoryLoadMore()

  functions_contact_person()
  functions_service_description()
  functions_contract()
  functions_contract_extra()
  functions_quality_control()
  functions_attachment()
  functions_notes()

  document.getElementById('offcanvasRight').addEventListener('hidden.bs.offcanvas', function(e) {
    dirty = false
    // 🚨 `eventCalendar = null` lived here and THREW on every offcanvas close — F-85 took out the
    // `functions_event` import and call above but left this line, and `window.eventCalendar` was declared
    // in that module (`functions_event.js:51`). A pack is an ES module, so it runs in strict mode, where
    // assigning to an undeclared name is a `ReferenceError` rather than a silent global — which is why a
    // dead assignment became an uncaught error instead of a no-op. Found on dev 2026-10-13 while looking
    // at something else (`TODO.md` F-125); it had shipped to production.
    // 📌 The dead `eventCalendar = null` went with the events UI in `T-101`; kept as a note because the
    // failure mode is the reusable part — a stale assignment in an ES module is a ReferenceError, not a
    // silent global.
  })

  $('#offcanvasRight').on('change', '#customer_country', function(event) {
    if ($(this).val() === 'FINLAND') {
      $('.billing_information').removeClass('d-none')
    } else {
      $('.billing_information').addClass('d-none')
    }
  })

  $('#offcanvasRight').on('change', '#customer_is_private', function(event) {
    if ($(this).is(':checked')) {
      $('#customer_business_id').val('')
      $('#customer_business_id').prop("disabled", true)
      $('#einvoicing_data').prop("disabled", true)
    } else {
      $('#customer_business_id').prop("disabled", false)
      $('#einvoicing_data').prop("disabled", false)
    }
  })

  $('#offcanvasRight').on('change', '#customer_status', function(event) {
    if ($(this).val() === 'ASIAKAS' || $(this).val() === 'PÄÄTTYNYT') {
      $('.contract_end_row').removeClass('d-none')
    } else {
      $('.contract_end_row').addClass('d-none')
    }

    if ($(this).val() === 'HÄVITTY') {
      $('#customer_status_lost_reason').closest('.row').removeClass('d-none')
      $('#customer_extra_data').val('status_havitty')
    } else {
      $('#customer_status_lost_reason').closest('.row').addClass('d-none')
      $('#customer_extra_data').val('')
    }
  })

  $('#offcanvasRight, #mainModal').on('change', '.select_customer_contact_person', function(event) {
    let customerId = $("#mainForm").attr('action').split('/')[2]
    const id = $(this).val()
    const tab = $("#offcanvasRight .tab-pane.active").attr('id')
    if (tab === 'events') {
      $('#event_contact_person_id').val(id)
    } else if (tab === 'basic-information' && $('#mainModal').hasClass('show')) {
      $('#mainModal input[name*="contact_person_id"]').val(id)
    } else if (tab === 'contracts') {
      $('#contract_contact_person_id').val(id)
    } else if (tab === 'notes') {
      $(this).closest('.note_row').find('input[name*="[contact_person_id]"]').val(id)
    }
    
    const $cp = $(this).closest('.contact_person')
    if (id) {
      lockButton(event.currentTarget)

      request.get(`/customers/${customerId}/contact_people/${id}`)
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
        .then(res => {
          $cp.find('input[name*="first_name"]').val(res.body.first_name).prop("disabled", res.body.deleted)
          $cp.find('input[name*="last_name"]').val(res.body.last_name).prop("disabled", res.body.deleted)
          $cp.find('input[name*="phone"]').val(res.body.phone).prop("disabled", res.body.deleted)
          $cp.find('input[name*="email"]').val(res.body.email).prop("disabled", res.body.deleted)
          $cp.find('input[name*="title"]').val(res.body.title).prop("disabled", res.body.deleted)

          unlockButton(event.currentTarget)
        })
        .catch(err => {
          handleErrors(err, event.currentTarget)
        })
    } else {
      $cp.find('input[name*="first_name"]').val('').prop("disabled", false)
      $cp.find('input[name*="last_name"]').val('').prop("disabled", false)
      $cp.find('input[name*="phone"]').val('').prop("disabled", false)
      $cp.find('input[name*="email"]').val('').prop("disabled", false)
      $cp.find('input[name*="title"]').val('').prop("disabled", false)
    }
  })

  $('#offcanvasRight').on('change', '#customer_user_id', function(event) {
    const id = $(this).val()
    
    if (id) {
      lockButton(event.currentTarget)

      request.get(`/users/${id}`)
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
        .then(res => {
          $(this).closest('.row').find('input[name*="first_name"]').val(res.body.firstName)
          $(this).closest('.row').find('input[name*="last_name"]').val(res.body.lastName)
          $(this).closest('.row').find('input[name*="phone"]').val(res.body.phone)
          $(this).closest('.row').find('input[name*="email"]').val(res.body.email)

          unlockButton(event.currentTarget)
        })
        .catch(err => {
          handleErrors(err, event.currentTarget)
        })
    } else {
      $(this).closest('.row').find('input[name*="first_name"]').val('')
      $(this).closest('.row').find('input[name*="last_name"]').val('')
      $(this).closest('.row').find('input[name*="phone"]').val('')
      $(this).closest('.row').find('input[name*="email"]').val('')
    }
  })

  $('#offcanvasRight').on('click', '#sub_inc_loc', function(event) {
    withDirtyGuard(function () {
      lockButton('#sub_inc_loc')
      const customerId = $("#mainForm").attr('action').split('/')[2]
      $.getScript('/customers/' + customerId + '/basic_informations/new')
    })
  })

  $('#mainModal').on('click', '#confirmDelete', function(event) {
    if ($("#mainForm").length && $("#mainForm").attr('action').includes('basic_informations')) {
      $(this).blur()
      lockButton('#confirmDelete')

      // T-111: `deleteRecord` clears `dirty` before this `.then` runs. F-148's note still applies and is
      // why it must be cleared at all: this response navigates (`window.location = '/customers'`), so a
      // stale flag reaches `beforeunload` and raises the BROWSER's "leave site?" dialog on a deleted record.
      deleteRecord($("#mainForm").attr('action'), { accept: 'text/javascript' })
        .catch(err => {
          handleErrors(err, '#confirmDelete')
        })
    }
  })

  $('#offcanvasRight').on('click', '.add_fields.add_event', function(event) {
    dirty = true

    var regexp, time
    time = new Date().getTime()
    regexp = new RegExp($(this).data('id'), 'g')
    if ($(this).hasClass('add_event')) {
      $(this).closest('.tab-pane').find('.event_rows').append($(this).data('fields').replace(regexp, time))
    }

    $(this).blur()

    return event.preventDefault()
  })

  $('#offcanvasRight, #mainModal').on('click', '.send-mail', function(event) {
    lockButton(this)
    let recipient = ''
    let first_name = $(this).closest('.row').find('input[name*="first_name"]').first().val().trim()
    let last_name = $(this).closest('.row').find('input[name*="last_name"]').first().val().trim()
    let email = $(this).closest('.row').find('input[name*="email"]').first().val().trim()
    if (email.length) {
      email = '<' + email + '>'
    }
    recipient = [first_name, last_name, email].join(' ').trim()

    let dynamicLink = $('<a>', {
      href: "mailto:" + recipient,
      css: { display: 'none' }
    })

    $('body').append(dynamicLink)
    dynamicLink[0].click()
    dynamicLink.remove()

    unlockButton(this)
  })

  $('#offcanvasRight').on('click', '.remove-file, .remove-area-file', function(event) {
    dirty = true

    let input = null
    if ($(this).hasClass('remove-file')) {
      input = $(this).closest('.col-4').find('input[type=hidden]')
    } else {
      input = $(this).closest('.d-block').find('input[type=hidden]')
    }
    let val = input.val()
    if (val.length) {
      val += ','
    }
    val += $(this).attr('data-id')
    input.val(val)

    $(this).closest('.row').hide()

    return event.preventDefault()
  })

  $('#offcanvasRight').on('click', '#einvoicing_data', function(event) {
    lockButton('#einvoicing_data')

    const businessId = $('#customer_business_id').val().trim()
    const country = $('#customer_country').find(':selected').val()
    if (!validateBusinessId(businessId, country)) {
      addToast(I18n.t("errors.wrong_business_id"), 'error')
      unlockButton('#einvoicing_data')
    } else {
      request.get('https://avoindata.prh.fi/opendata-ytj-api/v3/companies?businessId=' + businessId)
        .accept('json')
        .then(res => {
          if (res.body.companies && res.body.companies.length > 0) {
            let company = res.body.companies[0]
            let names1 = company.names.filter(obj => {
              return parseInt(obj.type) === 1
            })
            if (names1.length) {
              let name1 = names1.sort((a,b) => Date.parse(b.registrationDate) - Date.parse(a.registrationDate))[0]
              if (name1) {
                $('#customer_billing_name1').val(name1.name)
                if (!$('#customer_company_name').val().trim().length) {
                  $('#customer_company_name').val(name1.name)
                }
              }
            }
            let names2 = company.names.filter(obj => {
              return parseInt(obj.type) === 3
            })
            if (names2.length) {
              let name2 = names2.sort((a,b) => Date.parse(b.registrationDate) - Date.parse(a.registrationDate))[0]
              if (name2) {
                $('#customer_billing_name2').val(name2.name)
              }
            }

            let addresses = company.addresses.filter(obj => {
              return parseInt(obj.type) === 1
            })
            let billingAaddresses = company.addresses.filter(obj => {
              return parseInt(obj.type) === 2
            })

            if (addresses.length || billingAaddresses.length) {
              let ada = addresses
              if (!ada.length) {
                 ada = billingAaddresses
              }
              let adb = billingAaddresses
              if (!adb.length) {
                 adb = addresses
              }

              let address1 = ada.sort((a,b) => Date.parse(b.registrationDate) - Date.parse(a.registrationDate))[0]
              let address2 = adb.sort((a,b) => Date.parse(b.registrationDate) - Date.parse(a.registrationDate))[0]
              let postOffice1 = address1.postOffices.filter(obj => {
                return parseInt(obj.languageCode) === 1
              })[0]
              let postOffice2 = address2.postOffices.filter(obj => {
                return parseInt(obj.languageCode) === 1
              })[0]
              let addr = ''
              if (postOffice1) {
                addr = ''
                if (address1.street) {
                  addr = address1.street
                  if (address1.buildingNumber) {
                    addr += ' ' + address1.buildingNumber
                  }
                  if (address1.entrance) {
                    addr += ' ' + address1.entrance
                  }
                  if (address1.apartmentNumber) {
                    addr += ' ' + address1.apartmentNumber
                  }
                } else if (address1.postOfficeBox) {
                  addr = 'PL ' + address1.postOfficeBox
                }
                if (address1.co) {
                  addr = address1.co + ', ' + addr
                }
                if (!$('#customer_street_name').val().trim().length) {
                  $('#customer_street_name').val(addr)
                }
                if (!$('#customer_post_code').val().trim().length) {
                  $('#customer_post_code').val(address1.postCode)
                }
                if (!$('#customer_town').val().trim().length) {
                  $('#customer_town').val(postOffice1.city)
                }
              }
              if (postOffice2) {
                addr = ''
                if (address2.street) {
                  addr = address2.street
                  if (address2.buildingNumber) {
                    addr += ' ' + address2.buildingNumber
                  }
                  if (address2.entrance) {
                    addr += ' ' + address2.entrance
                  }
                  if (address2.apartmentNumber) {
                    addr += ' ' + address2.apartmentNumber
                  }
                } else if (address2.postOfficeBox) {
                  addr = 'PL ' + address2.postOfficeBox
                }
                if (address2.co) {
                  addr = address2.co + ', ' + addr
                }
                $('#customer_billing_street_name').val(addr)
                $('#customer_billing_post_code').val(address2.postCode)
                $('#customer_billing_town').val(postOffice2.city)
              } else {
                $('#customer_billing_street_name').val('')
                $('#customer_billing_post_code').val('')
                $('#customer_billing_town').val('')
              }

              if (company.website && company.website.url) {
                $('#customer_website').val(company.website.url)
              }

              if (company.mainBusinessLine && company.mainBusinessLine.descriptions) {
                let mainBusinessLine = company.mainBusinessLine.descriptions.filter(obj => {
                  return parseInt(obj.languageCode) === 1
                })
                if (mainBusinessLine && mainBusinessLine[0].description) {
                  $('#customer_industry').val(mainBusinessLine[0].description)
                }
              }
            }

            if (company.website && company.website.url) {
              $('#customer_website').val(company.website.url)
            }

            if (company.mainBusinessLine && company.mainBusinessLine.descriptions) {
              let mainBusinessLine = company.mainBusinessLine.descriptions.filter(obj => {
                return parseInt(obj.languageCode) === 1
              })
              if (mainBusinessLine && mainBusinessLine[0].description) {
                $('#customer_industry').val(mainBusinessLine[0].description)
              }
            }
          } else {
            addToast(I18n.t("errors.not_found_ytj"), 'alert')
            $('#customer_billing_name1').val('')
            $('#customer_billing_name2').val('')
            $('#customer_billing_street_name').val('')
            $('#customer_billing_post_code').val('')
            $('#customer_billing_town').val('')
            window.open('https://tietopalvelu.ytj.fi/yritys/' + businessId, '_blank')
          }

          unlockButton('#einvoicing_data')
        })
        .catch(err => {
          handleErrors(err, '#einvoicing_data')
        })

      request.get('/customers/einvoicing_data?business_id=' + businessId)
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
        .then(res => {
          if (res.body.operator) {
            $('#customer_billing_einvoice_operator').val(res.body.operator).trigger('change')
            $('#customer_billing_einvoice_address').val(res.body.address)
          } else {
            $('#customer_billing_einvoice_operator').val('').trigger('change')
            $('#customer_billing_einvoice_address').val('')
          }

          if (res.body.error0) {
            addToast(res.body.error0, 'alert')
          } else if (res.body.error1) {
            addToast(res.body.error1, 'alert')
            window.open('https://verkkolaskuosoite.fi/client/#/?searchText=' + businessId, '_blank')
          }
        })
        .catch(err => {
          handleErrors(err, null)
        })
    }
  })

  $('#offcanvasRight').on('click', '.show-googlemap', function(event) {
    $(this).prop("disabled", true)

    const address = $('#customer_street_name').val().trim()
    const postCode = $('#customer_post_code').val().trim()
    const town = $('#customer_town').val().trim()
    if (!address || !postCode || !town) {
      $(this).prop("disabled", false)
      addToast(I18n.t("errors.missing_address"), 'alert')
      return
    }
    const country = $('#customer_country').val()
    const totalAddress = address + ", " + postCode + " " + town

    const clientId = $('#customer_client_id').val()
    const buId = $('#customer_business_unit_id').val()
    request.get('/clients/' + clientId + '/business_units?id=' + buId)
      .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      .accept('json')
      .then(res => {
        showGoogleMap(mainModal, totalAddress, [{ address: totalAddress + ", " + country, color: res.body[0] && res.body[0].color }])
        $(this).prop("disabled", false)
      })
      .catch(err => {
        handleErrors(err, this)
      })
  })
}

function validateBusinessId(businessId, country) {
  if (country === 'ESTONIA') {
    if (businessId.length !== 8) {
      return false
    }
    if (!/^\d+$/.test(businessId)) {
      return false
    }
  } else if (country === 'FINLAND') {
    if (businessId.length !== 9) {
      return false
    }
    if (!/^\d{7}[-]\d{1}$/.test(businessId)) {
      return false
    }

    let total_count = 0
    const multipliers = [7, 9, 10, 5, 8, 4, 2]

    for(var i = 0; i < multipliers.length; i++) {
      total_count += multipliers[i] * parseInt(businessId[i])
    }

    let remainder = total_count % 11

    // Remainder 1 is not valid
    if (remainder === 1) {
      return false
    }

    // Remainder 0 leads into checksum 0
    if (remainder === 0) {
      if (parseInt(businessId.slice(-1)) !== 0) {
        return false
      } else {
        return true
      }
    }

    // If remainder is not 0, the checksum should be remainder deducted from 11
    if (parseInt(businessId.slice(-1)) !== 11 - remainder) {
      return false
    }
  }

  return true
}

// Main: poll job and continue after it has finished
window.checkStarttilomakeStatus = async function(jobId, send_starttilomake) {
  try {
    const r1 = await waitForJob(jobId, { intervalMs: 1000, timeoutMs: 60000 });
    if (send_starttilomake === 'true' && r1.result === 1) {
      fullscreenLoader.hide()
    } else {
      $('#basic-information-link button').click()
    }
  } catch (err) {
    handleErrors(err, null)
    fullscreenLoader.hide()
  }
}

export { customerFunctions }
